import './bootstrap.js'

// Bars that stay in view while scrolling and would otherwise cover the element we scroll to.
// Whether they actually stick is read at call time, so a bar that is only sticky on some
// pages — or from a certain breakpoint — never costs us an offset it does not need.
const STICKY_BARS = ['#navigation', '#bundle-navigation']

// Little breathing room between such a bar and the element below it
const SCROLL_GAP = 8

function stickyOffset () {
    return STICKY_BARS
        .map(selector => document.querySelector(selector))
        .filter(bar => bar && ['sticky', 'fixed'].includes(window.getComputedStyle(bar).position))
        .reduce((total, bar) => total + bar.clientHeight, 0)
}

window.scrollToElement = function (element, offset) {
    let target

    try {
        target = document.querySelector(element)
    } catch (e) {
        return
    }

    if (!target) {
        return
    }

    window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - stickyOffset() - SCROLL_GAP + (offset || 0),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    })
}

// Plain `#anchor` links (crawlable, work without JS) that smooth-scroll past the sticky navigation bars.
// `data-scroll-to` may hold a more specific selector; the href stays the no-JS fallback.
document.addEventListener('click', event => {
    const link = event.target.closest('a[data-scroll-to]')

    if (!link) {
        return
    }

    const target = [link.dataset.scrollTo, link.getAttribute('href')].find(selector => selector && document.querySelector(selector))

    if (!target) {
        return
    }

    event.preventDefault()

    window.scrollToElement(target)
})

window.setHash = function (hash) {
    window.location.hash = '#' + hash
}
